<script setup>
import RollTransition from "@/components/transitions/RollTransition.vue";
import {onMounted, onUnmounted, ref} from "vue";
import {shuffle} from "lodash";

const messages = [
  'You can ask me to completely rewrite your description in a new tone or style.',
  'You can say things like “make this sound more conversational” or “add a bit more energy.”',
  'I can remove or replace specific words — just tell it which ones you don’t want.',
  'You can ask for shorter, snappier copy — just say “make it punchier.”',
  'You can improve your call to action — try “encourage users to book today.”',
  'I can make it sound more professional, friendlier, or even funnier — your choice.',
  'You can ask for SEO tweaks, like “include the keyword teeth whitening.”',
  'You can ask me to match your brand tone — “make it sound more like us.”',
  'You can ask for a version that feels more local — “mention Manchester” for example.',
  'You can ask me to explain something more clearly or simplify the language.',
];

const shuffledMessages = shuffle(messages);

const currentIndex = ref(0);
const currentMessage = ref(shuffledMessages[currentIndex.value]);
const timerId = ref(null);

const nextString = () => {
  currentIndex.value = (currentIndex.value + 1) % shuffledMessages.length;
  currentMessage.value = shuffledMessages[currentIndex.value];
}

const startAnimation = () => {
  stopAnimation();
  timerId.value = setInterval(nextString, 30000);
}

const stopAnimation = () => {
  if (timerId.value) {
    clearInterval(timerId.value);
  }
  timerId.value = null;
}

const pauseAnimation = () => {
  stopAnimation();
}

const resumeAnimation = () => {
  if (!timerId.value) {
    startAnimation();
  }
}

onMounted(startAnimation);
onUnmounted(stopAnimation);
</script>

<template>
  <div
    class="tw-flex tw-flex-col tw-gap-2 tw-bg-info-100 tw-border tw-border-info tw-text-info tw-text-base tw-rounded-lg tw-px-4 tw-py-4 tw-leading-none"
    @mouseenter="pauseAnimation"
    @mouseleave="resumeAnimation"
  >
    <div class="tw-flex tw-items-center tw-gap-2">
      <svg-vue
        icon="icons/info"
        class="tw-h-8 tw-w-8 tw-text-info tw-shrink-0"
      />
      <span class="tw-font-bold">Did you know?</span>
    </div>
    <div class="tw-flex tw-items-center tw-h-9 tw-px-4">
      <RollTransition>
        <div :key="currentIndex">
          {{ currentMessage }}
        </div>
      </RollTransition>
    </div>
  </div>
</template>
